import React, { useState, useEffect, useRef } from 'react';
import LoadingSpinner from '@legacy-vfuk/core-loading-spinner';
import Button from '@legacy-vfuk/core-button';
import { BackPopupButtonStyles } from './styles/SectionAssessmentBusinessGoals.styles';
import ShowError from '../../ShowError';
import { ErrorDataTypes } from '../../Types/ShowError.types';
import '../../css/SurveyPage.css';
import { navigate } from 'gatsby';
import GoalsQuestions from './GoalsQuestions';
import {
  carouselCSS,
  goalsPageLoaderCSS,
} from '../../css/BusinessQuestions.styles';
import {
  SectionAssessmentBusinessGoalsProps,
  TwinPairQuestionsArrayTypes,
  RelatedAnswersTypes,
  ParmsTypes,
} from '../../Types/SectionAssessmentBusinessGoalsType';
import { AssessmentSlider } from '../../AssessmentSlider/AssessmentSlider';
import { AssessmentSliderRef } from '../../AssessmentSlider/types/AssessmentSlider.types';
import fireAssessmentCommonEvents from '../../../../../../helpers/fireAssessmentCommonEvents';
import fireStepChangeEvent from '../../../../../../helpers/fireStepChangeEvent';
import usePrevious from '../../../../../../hooks/usePrevious';
import { mocksUrls } from '../../__mocks__/AssesssmentService.mocks';
import twinxClient from '../../../SectionSmartSearch/ProtectedApiClient';

export const KOA_API_ENDPOINT = process.env.GATSBY_API_URL;
export const OPCO_CODE = process.env.GATSBY_OPCO_CODE;
export const LANG_CODE = process.env.GATSBY_LANG_CODE;

const scrollToRef = ref =>
  window.scrollTo({ top: ref?.current?.offsetTop - 200 });

const SectionAssessmentBusinessGoals = ({
  content,
}: SectionAssessmentBusinessGoalsProps) => {
  const [twinPairQuestionsArray, setTwinPairQuestionsArray] =
    useState<TwinPairQuestionsArrayTypes>();
  const [getGoalsQuesLoader, setGetGoalsQuesLoader] = useState<boolean>(false);
  const [twinId, setTwinId] = useState<string>('');
  const [goalsSection, setGoalsSection] = useState<boolean>();
  const [relatedAnswers, setRelatedAnswers] = useState<RelatedAnswersTypes[]>(
    []
  );
  const [error, setError] = useState<ErrorDataTypes | null>(null);
  const carouselTop = useRef<HTMLDivElement>(null);
  const [errorApiCallName, setErrorApiCallName] = useState<string>('');
  const [parms, setParms] = useState<ParmsTypes>();
  const executeScroll = () => scrollToRef(carouselTop);
  const sliderRef = useRef<AssessmentSliderRef | null>(null);
  const [activeSlide, setActiveSlide] = useState<number>(0);
  const [nextButton, setNextButton] = useState<HTMLButtonElement | null>(null);
  const [nextButtonDisabled, setNextButtonDisabled] = useState<boolean>(true);
  const [slideChangeExecutedManually, setSlideChangeExecutedManually] =
    useState<boolean>(false);
  const prevSlide = usePrevious(activeSlide);

  const getAssessmentAPI = async (
    surveyId: any,
    gettype: any,
    twinxId: any
  ) => {
    setGetGoalsQuesLoader(true);

    const query: any = {
      Opco: OPCO_CODE,
      Language: LANG_CODE,
      surveyid: surveyId,
      get: gettype,
      twinid: twinxId,
    };

    const params = new URLSearchParams(query).toString();
    const Url = KOA_API_ENDPOINT
      ? `${KOA_API_ENDPOINT}/assessment?${params}`
      : mocksUrls.SurveyPageGet;

    try {
      const { data } = await twinxClient.get(Url);

      if (!data?.result?.hasOwnProperty('code')) {
        setTwinId(data?.result?.interactionItem[0]?.id);
        await setTwinPairQuestionsArray(data?.result?.interactionItem[0]);
        setTimeout(() => {
          carouselPreBtn('1');
          carouselNxtBtn('');
        }, 1000);
        setGoalsSection(true);
      } else {
        console.log(
          'There is some problem in patching and getting the answers'
        );
        setGoalsSection(false);
        setError({
          errorContent: content.serverError,
          errorType: 'serverError',
        });
        setErrorApiCallName('getAssessmentAPI');
      }
      setGetGoalsQuesLoader(false);
      executeScroll();
    } catch (error) {
      console.log(error);
      apiErrorHandler();
      setErrorApiCallName('getAssessmentAPI');
    }
  };

  const patchGoalsAnswersAPI = async (surveyId: any, body: any) => {
    const subCategory = window.history.state.subCategory;
    const businessName = window.history.state.businessName;
    setGetGoalsQuesLoader(true);

    const query: any = {
      Opco: OPCO_CODE,
      Language: LANG_CODE,
      surveyid: surveyId,
    };
    const params = new URLSearchParams(query).toString();
    const url = KOA_API_ENDPOINT
      ? `${KOA_API_ENDPOINT}/assessment?${params}`
      : mocksUrls.SurveyPagePatch;

    try {
      const { data } = await twinxClient.patch(url, body);

      if (!data?.result?.hasOwnProperty('code')) {
        setTwinId(data?.result?.id);
        navigate(content.assessmentSummaryPageSlug, {
          state: {
            emailsurveyid: surveyId,
            twinid: data?.result?.id,
            subcategory: subCategory,
            businessName: businessName,
          },
        });
      } else {
        console.log('There is some problem in patching the answers');
        setGetGoalsQuesLoader(false);
        setGoalsSection(false);
        executeScroll();
        setError({
          errorContent: content.serverError,
          errorType: 'serverError',
        });
        setErrorApiCallName('patchGoalsAnswersAPI');
      }
    } catch (error) {
      console.log(error);
      apiErrorHandler();
      setErrorApiCallName('patchGoalsAnswersAPI');
    }
  };

  const apiErrorHandler = () => {
    setGoalsSection(false);
    setGetGoalsQuesLoader(false);
    executeScroll();
    if (!window.navigator.onLine) {
      setError({
        errorContent: content.noInternetError,
        errorType: 'noInternetError',
      });
    } else {
      setError({ errorContent: content.serverError, errorType: 'serverError' });
    }
  };

  const goalsSecPropFunction = (qnum: number, action: string) => {
    if (qnum !== twinPairQuestionsArray?.item.question.length) {
      carouselNxtBtn(action);
    }
  };

  const updateGoalsResponse = (
    mainQID: string,
    mainExtID: string,
    mainResp: any,
    relatedQuestions: any = ''
  ) => {
    const currentAns: any = {
      id: mainQID,
      externalId: mainExtID,
      response: {
        responseText: [mainResp],
      },
    };

    const checkRelatedAnswers = relatedAnswers.findIndex(
      (obj: any) => obj.id === currentAns.id
    );

    if (checkRelatedAnswers === -1) {
      setRelatedAnswers((relatedAnswers: any) => [
        ...relatedAnswers,
        currentAns,
      ]);
    } else {
      if (relatedQuestions === '') {
        setRelatedAnswers(
          relatedAnswers.map((obj: any) => {
            return obj.id === currentAns.id ? currentAns : obj;
          })
        );
      } else {
        getIfStatment(currentAns, relatedQuestions, mainQID);
      }
    }
  };

  const getIfStatment = (
    currentAns: any,
    relatedQuestions: any,
    mainQID: string
  ) => {
    const filterOuterID = relatedAnswers.filter((obj: any) => {
      return obj.id === currentAns.id;
    });
    if (filterOuterID[0].hasOwnProperty('relatedQuestion')) {
      const relatedQuestion = filterOuterID[0].relatedQuestion.findIndex(
        (obj: any) =>
          obj.externalId === relatedQuestions.externalId &&
          obj.question.id === relatedQuestions.question.id
      );
      if (relatedQuestion === -1) {
        const newAnswer = filterOuterID[0];
        newAnswer.relatedQuestion.push(relatedQuestions);
        setRelatedAnswers(
          relatedAnswers.map((obj: any) => {
            return obj.id === mainQID ? newAnswer : obj;
          })
        );
      } else {
        const replaceAnswer = filterOuterID[0];
        replaceAnswer.relatedQuestion[relatedQuestion] = relatedQuestions;
        setRelatedAnswers(
          relatedAnswers.map((obj: any) => {
            return obj.id === mainQID ? replaceAnswer : obj;
          })
        );
      }
    } else {
      Object.assign(currentAns, { relatedQuestion: [relatedQuestions] });
      setRelatedAnswers(
        relatedAnswers.map((obj: any) => {
          return obj.id === currentAns.id ? currentAns : obj;
        })
      );
    }
  };
  const customParam = () => {
    if (errorApiCallName === 'getAssessmentAPI') {
      getAssessmentAPI(
        window.history.state.surveyId,
        'twinquestion',
        window.history.state.twinid
      );
    } else if (errorApiCallName === 'patchGoalsAnswersAPI') {
      patchGoalsAnswersAPI(window.history.state.surveyId, parms);
    }
  };

  const nextBusinessEvent = async (getRelatedAnswers: any, qnum: any) => {
    goToNextSlide();

    const category = [
      {
        name: window.history.state.categorySelected,
        subCategory: [
          {
            name: window.history.state.subCategory,
          },
        ],
      },
    ];

    const businessGoalsAPIPatch = {
      direction: 'inbound',
      reason: 'Customer has answered the twin questionnaire',
      status: 'Completed',
      interactionItem: [
        {
          item: {
            id: twinId,
            category,
            question: getRelatedAnswers,
          },
        },
      ],
    };

    fireAssessmentCommonEvents(content.nextButton.label);

    if (twinPairQuestionsArray?.item.question.length === qnum + 1) {
      await patchGoalsAnswersAPI(
        window.history.state.surveyId,
        businessGoalsAPIPatch
      );
      setParms(businessGoalsAPIPatch);
    } else {
      const carNextIcon: any = document.getElementsByClassName(
        'carousel__next-button'
      );
      if (carNextIcon[0] !== undefined) {
        carNextIcon[0].click();
      }
      executeScroll();
    }
  };

  const goalsQuestions =
    twinPairQuestionsArray &&
    Object.keys(twinPairQuestionsArray).length > 0 &&
    twinPairQuestionsArray.item.question.length > 0 &&
    twinPairQuestionsArray.item.question.map((item: any, qnum: any) => {
      if (
        twinPairQuestionsArray &&
        Object.keys(twinPairQuestionsArray).length > 0 &&
        twinPairQuestionsArray.item.question.length > 0
      ) {
        return (
          <GoalsQuestions
            key={qnum}
            content={content}
            qnum={qnum}
            item={item}
            twinPairQuestionsArray={twinPairQuestionsArray}
            goalsSecPropFunction={goalsSecPropFunction}
            nextBusinessEvent={nextBusinessEvent}
            nextButtonDisabled={nextButtonDisabled}
            setNextButtonDisabled={setNextButtonDisabled}
            updateGoalsResponse={updateGoalsResponse}
            relatedAnswer={relatedAnswers}
          />
        );
      } else if (getGoalsQuesLoader) {
        return (
          <div css={goalsPageLoaderCSS}>
            <LoadingSpinner appearance="secondary" size={5} />
          </div>
        );
      } else {
        return (
          <AssessmentSlider key={qnum}>
            ( error &&
            <ShowError
              errorContent={error && error.errorContent}
              errorType={error && error.errorType}
            />
            )
          </AssessmentSlider>
        );
      }
    });

  const carouselPreBtn = (qusNum: string) => {
    const carouselLeftBtn: any = document.querySelector(
      '.carousel__control--left'
    );
    const customLeftBtn: any = document.querySelector('.custom__control--left');
    if (carouselLeftBtn !== null) {
      const goalsQuesBtn: any = document.getElementById(`bgnt-${qusNum}`);
      const carouselLeftSpan: any = carouselLeftBtn.querySelector('span');
      carouselLeftSpan.classList.remove('visually-hidden');
      carouselLeftBtn.classList.add('active');
      const questionNum = parseInt(qusNum) <= 1;
      carouselLeftSpan.textContent = questionNum
        ? content.carouselLabels.backButtonLabel
        : content.carouselLabels.previousButtonLabel;
      carouselLeftBtn.style.visibility = questionNum ? 'hidden' : 'visible';
      customLeftBtn.style.visibility = questionNum ? 'visible' : 'hidden';
      carouselNxtBtn(goalsQuesBtn && goalsQuesBtn.disabled ? '' : 'enable');
      if (goalsQuesBtn && !goalsQuesBtn.disabled) {
        carouselNxtBtn('enable');
      } else {
        carouselNxtBtn('');
      }
    }
  };

  const carouselNxtBtn = (action: string) => {
    const carouselRightBtn: any = document.querySelector(
      '.carousel__control--right'
    );
    if (carouselRightBtn !== null) {
      const carouselRightSpan: any = carouselRightBtn.querySelector('span');
      carouselRightSpan.classList.remove('visually-hidden');
      carouselRightSpan.textContent = content.carouselLabels.nextButtonLabel;
      if (action === 'enable') {
        carouselRightBtn.classList.remove('btn-disabled');
        carouselRightBtn.classList.add('active');
      } else {
        carouselRightBtn.classList.add('btn-disabled');
        carouselRightBtn.classList.remove('active');
      }
    }
  };

  useEffect(() => {
    if (goalsSection) {
      const carouselLeftBtn: any = document.querySelector(
        '.carousel__control--left'
      );
      const carouselRightBtn: any = document.querySelector(
        '.carousel__control--right'
      );
      if (carouselLeftBtn !== null) {
        let carosuelSlideEle, carosuelActiveEle, activeCarouselItem;
        carouselLeftBtn.addEventListener('click', () => {
          carosuelSlideEle = document.getElementsByClassName('carousel__slide');
          carosuelActiveEle = [...carosuelSlideEle].filter(element =>
            element.classList.contains('carousel__slide--active')
          );
          activeCarouselItem =
            parseInt(
              carosuelActiveEle[0].children[0].children[0].classList[0].slice(
                -1
              )
            ) - 1;
          carouselPreBtn(activeCarouselItem.toString());
        });
        carouselRightBtn.addEventListener('click', () => {
          carosuelSlideEle = document.getElementsByClassName('carousel__slide');
          carosuelActiveEle = [...carosuelSlideEle].filter(element =>
            element.classList.contains('carousel__slide--active')
          );
          activeCarouselItem =
            parseInt(
              carosuelActiveEle[0].children[0].children[0].classList[0].slice(
                -1
              )
            ) + 1;
          carouselPreBtn(activeCarouselItem.toString());
        });
      }
    }
  });

  // stay/leave modal
  const navigateBack = () => {
    const goalQuestModal = document.getElementById('goalQstModal');
    if (goalQuestModal) {
      goalQuestModal.style.display = 'block';
    }
  };

  /**
   * useEffect implemented to set the first render of the previous slide carousel button
   * to invoke the modal of 'stay'/'leave' options
   */
  useEffect(() => {
    if (!getGoalsQuesLoader && activeSlide === 0) {
      setTimeout(() => {
        let foundPrevButton: HTMLButtonElement;
        foundPrevButton = document.querySelector(
          '.slick-prev'
        ) as HTMLButtonElement;
        if (foundPrevButton) {
          foundPrevButton.onclick = () => navigateBack();
        }
      });
    }
  }, [getGoalsQuesLoader, activeSlide]);

  useEffect(() => {
    if (prevSlide !== undefined) {
      // because the initial page view event is already being handled by the Tealium Page Change Script
      fireStepChangeEvent();
    }
  }, [activeSlide]);

  /**
   *   Ensure that the next buttons are enabled when prev button selected
   *   and next buttons are disabled when next button is selected and no fields are selected
   */
  const onSlideChange = (current: number, next: number) => {
    if (relatedAnswers[next]) {
      setNextButtonDisabled(false);
    } else {
      setNextButtonDisabled(true);
    }
    if (!slideChangeExecutedManually) {
      fireAssessmentCommonEvents(
        next > current ? 'right arrow' : 'left arrow',
        'pointer click'
      );
    } else {
      setSlideChangeExecutedManually(false);
    }
    setActiveSlide(next);
  };

  useEffect(() => {
    if (slideChangeExecutedManually) {
      sliderRef.current?.nextSlide();
      setNextButtonDisabled(true);
    }
  }, [slideChangeExecutedManually]);

  const goToNextSlide = () => {
    setSlideChangeExecutedManually(true);
  };

  useEffect(() => {
    let timerNext: NodeJS.Timeout;
    if (!getGoalsQuesLoader) {
      setTimeout(() => {
        const foundNextButton = document.querySelector(
          '.slick-next'
        ) as HTMLButtonElement;
        if (foundNextButton) {
          setNextButton(foundNextButton);
        }
      });
    }
    return () => {
      clearTimeout(timerNext);
    };
  }, [getGoalsQuesLoader]);

  useEffect(() => {
    enableDisableNextButton();
  }, [nextButton, nextButtonDisabled]);

  const enableDisableNextButton = () => {
    if (nextButton) {
      if (nextButtonDisabled) {
        nextButton.onclick = ev => {
          ev.preventDefault();
          ev.stopPropagation();
        };
        nextButton.style.cursor = 'not-allowed';
        nextButton.style.opacity = '0.25';
      } else {
        nextButton.onclick = () => {};
        nextButton.style.cursor = 'pointer';
        nextButton.style.opacity = '1';
      }
    }
  };

  const historyStateUpdate = () => {
    if (window.history.state !== null) {
      getAssessmentAPI(
        window.history.state.surveyId,
        'twinquestion',
        window.history.state.twinid
      );
    } else {
      return navigate(content.aboutYourBusinessPageSlug);
    }
  };

  useEffect(() => {
    historyStateUpdate();
  }, []);

  const stayGoalQuestionClick = () => {
    const stayGoalQst = document.getElementsByClassName(
      'goalQuestModal'
    )[0] as HTMLElement;
    stayGoalQst.style.display = 'none';
  };

  if (getGoalsQuesLoader) {
    return (
      <div className="spring">
        <div css={goalsPageLoaderCSS}>
          <LoadingSpinner appearance="secondary" size={5} />
        </div>
      </div>
    );
  } else if (goalsSection) {
    /**
     * Assigning the appearance of buttons to match accepted source web appearance
     * types from passed dcl attributes
     */
    const regEx = /^(tertiary|none|transparent)$/;
    if (
      regEx.test(content.carouselLabels.backButtonPopup.navigateButton.rank)
    ) {
      content.carouselLabels.backButtonPopup.navigateButton.rank = 'alt1';
    }
    if (regEx.test(content.carouselLabels.backButtonPopup.stayButton.rank)) {
      content.carouselLabels.backButtonPopup.stayButton.rank = 'secondary';
    }

    return (
      <div>
        <div id="goalQstModal" className="goalQuestModal">
          <div className="goalQuestModal-content">
            <div className="gqm-content">
              <div className="warning-icon">
                <img
                  src={content.carouselLabels.backButtonPopup.topImage.file.url}
                ></img>
              </div>
              <p className="warning-para">
                {content.carouselLabels.backButtonPopup.description}
              </p>
              <BackPopupButtonStyles>
                {/*leaveGoalsQuestion*/}
                <Button
                  text={
                    content.carouselLabels.backButtonPopup.navigateButton.label
                  }
                  appearance={
                    content.carouselLabels.backButtonPopup.navigateButton.rank
                  }
                  onClick={() => {
                    navigate(-1);
                  }}
                />
                {/*stayGoalQuestion*/}
                <Button
                  text={content.carouselLabels.backButtonPopup.stayButton.label}
                  appearance={
                    content.carouselLabels.backButtonPopup.stayButton.rank
                  }
                  onClick={stayGoalQuestionClick}
                />
              </BackPopupButtonStyles>
            </div>
          </div>
        </div>

        <div className="carouselParent" css={carouselCSS} ref={carouselTop}>
          <div className="spring">
            <AssessmentSlider ref={sliderRef} beforeChange={onSlideChange}>
              {goalsQuestions}
            </AssessmentSlider>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="spring">
        <AssessmentSlider>
          {error && (
            <ShowError
              errorContent={error.errorContent}
              errorType={error.errorType}
              customParam={customParam}
            />
          )}
        </AssessmentSlider>
      </div>
    );
  }
};

export default SectionAssessmentBusinessGoals;
